export default __webpack_public_path__ + "static/media/struct2.471d7063.png";